import React, { FC } from 'react';
import { TableGroupModel } from '../../../models/index.model';
import { TNormalRowItemProps } from '../../../types/index.types';
import LeftMostCell from './leftMostCell';
import SpecCell from './specCell';

const NormalRow: FC<TNormalRowItemProps> = (props) => {
  const { model, obj, index, showHiddenRightCells } = props;

  const lastRow =
    model.items.length === index + 1 || (index + 1 < model.items.length && model.items?.[index + 1] instanceof TableGroupModel);

  return (
    <tr key={`model-detail-specification-table__spec-category-row-${obj.title}`}>
      {!model.hideRowsHeader && obj.title?.value && (
        <td className="model-detail-specification-table__table-cell--left-most model-detail-specification-table__left-most-cell">
          <div
            className={`
                model-detail-specification-table__left-side-accordion-spec-title
                ${lastRow ? 'model-detail-specification-table__left-side-accordion-spec-title--border-hidden' : ''}
            `}
          >
            <LeftMostCell row={obj} />
          </div>
        </td>
      )}
      {model.colHeadings?.map((spec, specIndex) => (
        <SpecCell
          key={`model-detail-specification-table-spec-${obj.title?.value}-${spec.text}`}
          specIndex={specIndex}
          subObj={obj}
          fadeIn={false}
          hide={false}
          lastRow={lastRow}
          showHiddenRightCells={showHiddenRightCells}
        />
      ))}
    </tr>
  );
};

export default NormalRow;
